import React, { useEffect } from "react";
import { Button, Card, CardBody, Table, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";
import PanelHeader from "components/panelheader/panelHeader";
import PaginationControls from "components/paginationcontrols/paginationControls";
import { usePageLoading } from "hooks/usePageLoading";
import { getJugadores, deleteJugador, importJugadores } from "services/jugadoresService";
import { getConfig } from "config/config";
import { toastBigError, toastConfirm, toastBigSuccess } from "components/utils/toasts";
import { cleanString } from "components/utils/cleanString";
import { paginate } from "components/utils/paginate";
import _ from "lodash";
import moment from "moment";

const Jugadores = (props) => {
  const doneLoading = usePageLoading(props);
  const [allRecords, setAllRecords] = React.useState([]);
  const [isImporting, setIsImporting] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [sortColumn, setSortColumn] = React.useState({ path: "apellido", order: "asc" });
  const [searchQuery, setSearchQuery] = React.useState("");
  const config = getConfig();
  const pageSize = config.recordsPerPage;
  const navigate = useNavigate();

  const importRef = React.useRef(null);

  const fetchData = async () => {
    try {
      const records = await getJugadores();
      if (records === "NETWORK ERROR") toastBigError("Error", "Error de Conexión");
      else setAllRecords(records);
    } catch {
    } finally {
      doneLoading();
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {}, [allRecords, isImporting]);

  const getPagedData = () => {
    let filtered = [];
    if (searchQuery.trim().length > 0) {
      filtered = allRecords.filter(
        (m) =>
          cleanString(m.apellido).includes(cleanString(searchQuery)) ||
          cleanString(m.nombre).includes(cleanString(searchQuery)) ||
          cleanString(m.dni).includes(cleanString(searchQuery)),
      );
    } else {
      filtered = allRecords;
    }
    const ordered = _.orderBy(
      filtered,
      [
        (item) => {
          const value = item[sortColumn.path];
          return typeof value === "string" ? value.toLowerCase() : value;
        },
      ],
      [sortColumn.order],
    );
    const records = paginate(ordered, currentPage, pageSize);
    return { totalCount: filtered.length, records };
  };

  const { totalCount, records } = getPagedData();
  if (currentPage > Math.ceil(totalCount / pageSize) && totalCount > 0)
    setCurrentPage(Math.ceil(totalCount / pageSize));

  // const labelPages = Math.ceil(totalCount / pageSize) > 1 ? currentPage + "/" + Math.ceil(totalCount / pageSize) : "";

  const thead = [
    { header: "Apellido", width: "30%", sortColumn: "apellido" },
    { header: "Nombre", width: "30%", sortColumn: "nombre" },
    { header: "DNI", width: "15%", sortColumn: "dni" },
    { header: "Fecha Nacimiento", width: "15%", sortColumn: "fechaNacimiento" },
    { header: "", width: "5%" },
    { header: "", width: "5%" },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNew = () => {
    navigate("/admin/jugadores/nuevo", {
      state: { action: "A" },
    });
  };

  const handleView = (id) => {
    navigate("/admin/jugadores/" + id, {
      state: { action: "C" },
    });
  };

  const handleEdit = (id) => {
    navigate("/admin/jugadores/" + id, {
      state: { action: "E" },
    });
  };

  const handleDelete = async (id) => {
    toastConfirm("¿ Eliminar jugador ?", "Se eliminarán todas los datos de este jugador en los torneos", () =>
      doDelete(id),
    );
  };

  const doDelete = async (id) => {
    const originalRecords = allRecords;
    const records = allRecords.filter((m) => m._id !== id);
    setAllRecords(records);
    try {
      await deleteJugador(id);
    } catch (ex) {
      if (ex.response && ex.response.status === 404) toastBigError("Ese registro ya fue eliminado");
      setAllRecords(originalRecords);
    }
  };

  const handleImportar = () => {
    importRef.current.click();
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.currentTarget.value);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsImporting(true);
    const data = await importJugadores(file);
    if (data.success) {
      setAllRecords(data.records);
      setIsImporting(false);
      await toastBigSuccess("Importación Exitosa", "El listado de jugadores ha sido importado correctamente");
    } else {
      setIsImporting(false);
      toastBigError("Error", "Ha ocurrido un error durante la importación");
    }
  };

  const setOrder = (path) => {
    if (sortColumn.path === path) {
      setSortColumn({ path, order: sortColumn.order === "asc" ? "desc" : "asc" });
    } else {
      setSortColumn({ path, order: "asc" });
    }
  };

  return (
    <>
      {isImporting && (
        <div className="loading-overlay" id="loadingOverlay">
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <span className="mt-2">Importando archivo...</span>
          </div>
        </div>
      )}
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              {/* <CardHeader>al tratar de importar
                <CardTitle>
                  <Row className="align-items-center">
                    <Col>
                      <h4 className="pull-left" color="black">
                        <strong>Sedes</strong>
                      </h4>
                    </Col>
                    <Col>
                      <Button className="pull-right btn-arhock" onClick={() => handleNew()}>
                        Nueva Sede
                      </Button>
                    </Col>
                  </Row>
                </CardTitle>
              </CardHeader> */}
              <CardBody>
                <Row className="align-items-center">
                  {/* <Col>
                      <h4 className="pull-left" color="black">
                        <strong>Sedes</strong>
                      </h4>
                    </Col> */}
                  <Col>
                    <Button className="pull-right btn-arhock" onClick={() => handleNew()}>
                      Nuevo Jugador
                    </Button>

                    <Button className="pull-right btn-importar" onClick={() => handleImportar()}>
                      Importar Listado
                    </Button>
                    <input
                      type="file"
                      className="d-none"
                      ref={importRef}
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="mb-3 mt-3 col-9"></Col>
                  <Col className="mb-3 mt-3 col-3">
                    <input
                      id="searchBox"
                      type="search"
                      placeholder="Buscar..."
                      onChange={handleSearchChange}
                      className="form-control form-control-sm"
                      value={searchQuery}
                    />
                  </Col>
                </Row>
                <Table responsive hover>
                  <thead className="text-black">
                    <tr>
                      {thead.map((prop, key) => {
                        if (key === thead.length - 2)
                          return (
                            <th key={key} className="text-left" style={prop.width ? { width: `${prop.width}` } : ""}>
                              {prop.header}
                            </th>
                          );
                        return (
                          <th
                            key={key}
                            className="clickable"
                            color="black"
                            onClick={() => setOrder(prop.sortColumn)}
                            style={prop.width ? { width: `${prop.width}` } : ""}
                          >
                            {prop.header}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((item) => (
                      <tr key={Math.random()}>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{item.apellido}</span>
                        </td>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{item.nombre}</span>
                        </td>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{item.dni}</span>
                        </td>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{moment(item.fechaNacimiento).format("DD/MM/YYYY")}</span>
                        </td>
                        <td>
                          <span className="clickable" onClick={() => handleEdit(item._id)}>
                            <div className="icon icon-success">
                              <i className="fa fa-pencil-square-o" color="success" />
                            </div>
                          </span>
                        </td>
                        <td>
                          <span className="clickable" onClick={() => handleDelete(item._id)}>
                            <div className="icon icon-danger">
                              <i className="fas fa-trash-alt" color="danger" />
                            </div>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Row className="pull-right">
                  <PaginationControls
                    onPageChange={(page) => handlePageChange(page)}
                    itemsCount={totalCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                  />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Jugadores;
